import * as actions_style from './actions.style.js';

const tableStyles = {
  actions: actions_style
};

export { tableStyles };
//# sourceMappingURL=index.js.map
